import { Routes } from '@angular/router';

import { MpsLoggedInGuard } from '../mps/guards/mps-loggedin.guard';
import { applicationRouteNames } from './application-route-names';

export const applicationRoutes: Routes = [
  /*
  {
    path: applicationRouteNames.home,
    loadChildren: () => import('./mps-home/mps-home.routes').then((m) => m.mpsHomeRoutes),
    data: { title: 'general.navigation.home' },
    canActivate: [MpsLoggedInGuard],
    canLoad: [],
  },
  {
    path: applicationRouteNames.administration,
    data: { title: 'general.navigation.administration' },
    canActivate: [MpsIsAdminGuard],
    canLoad: [MpsIsAdminGuard],
    children: [
      {
        path: applicationRouteNames.users,
        loadComponent: () => import('./administration/users/list/list.component').then((m) => m.ListComponent),
        data: { title: 'general.navigation.users' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
      {
        path: applicationRouteNames.lokalise,
        loadComponent: () => import('./administration/lokalise/lokalise.component').then((m) => m.LokaliseComponent),
        data: { title: 'general.navigation.lokalise' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
    ],
  },
  */

  //@MPS_KIT::CRUD entity example

  {
    path: applicationRouteNames.hpc,
    loadChildren: () => import('@app/modules/hpc/hpc.routes').then((m) => m.HPC_ROUTES),
    data: { title: 'general.navigation.hpc' },
    canActivate: [MpsLoggedInGuard],
  },
  {
    path: applicationRouteNames.dashboard,
    loadChildren: () => import('@app/modules/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
    data: { title: 'general.navigation.dashboard' },
    canActivate: [MpsLoggedInGuard],
  },
  {
    path: applicationRouteNames.lunch,
    loadChildren: () => import('@app/modules/lunches/lunches.routes').then((m) => m.LUNCH_ROUTES),
    data: { title: 'general.navigation.lunch' },
    canActivate: [MpsLoggedInGuard],
  },
  {
    path: applicationRouteNames.users,
    loadChildren: () => import('@app/modules/users/users.routes').then((m) => m.USERS_ROUTES),
    data: { title: 'general.navigation.users' },
    canActivate: [MpsLoggedInGuard],
    canLoad: [MpsLoggedInGuard],
  },
];
